import setupApplyForm from './modules/apply-form';
import setupRegisterForm from './modules/register-form';

setupApplyForm();
setupRegisterForm();

$('document').ready(function() {

    $('.hear_about_us').change(function() {
        if($('.hear_about_us').val() == 8) {
            $('.about_us_other').show();
        } else {
            $('.about_us_other').hide();
        }
        if($('.hear_about_us').val() == 10) {
            $('.employee_referral').show();
        } else {
            $('.employee_referral').hide();
        }
        if($('.hear_about_us').val() == 14) {
            $('.agency_name').show();
            //$('.info_accuracy_area').show();
            $('#app-form-line-break').before('<div class="info_accuracy_area col-xs-12">\n' +
                '        <div class="radio-area">\n' +
                '            <input id="info-accuracy-input&quot;" type="checkbox" name="information-accuracy" data-validate="checkbox" data-error-target="infoAccuracyError" data-validate-message="Please confirm that the information provided is accurate" class="careers-checkbox">\n' +
                '            If you are completing this process on behalf of someone else you confirm that:\n' +
                '            <ul>\n' +
                '                <li>The information inputted is accurate and complete; and</li>\n' +
                '                <li>You have communicated our <a href="http://www.stellantisandyou.co.uk/privacy-policy" target="_blank">Privacy Policy</a>\n' +
                '                    (included as link) to them.\n' +
                '                </li>\n' +
                '            </ul>\n' +
                '            <div id="infoAccuracyError"></div>\n' +
                '        </div>\n' +
                '    </div>');
            careersValidator.validate('careers-form');
        } else {
            $('.agency_name').hide();
            if($('.info_accuracy_area')) {
                $('.info_accuracy_area').remove();
            }
        }
    });
    $('.contact_all').click(function() {
        $('.select_all').prop('checked', $(this).prop('checked'));
    });


    if($('body').hasClass('search') && document.querySelector('#map')) {
        var mapTypeControl = true;
        var centre_lat = 52.3965786;
        var centre_lng = -1.4861696;

        var map = new google.maps.Map(document.getElementById('map'), {
            zoom: 6,
            mapTypeControl: mapTypeControl,
            center: new google.maps.LatLng(centre_lat, centre_lng),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            draggable: !("ontouchend" in document)
        });

        var infowindow = new google.maps.InfoWindow();

        var marker, i;
        $.each(dealers, function (index, dealer) {
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(dealer['latitude'], dealer['longitude']),
                map: map,
                icon: getMapIcon()
            });

            var group_name = '<h4>'+dealer.name+'</h4><a href="/careers/search-results/'+dealer.id+'?keyword='+keyword+'&position='+position+'&location='+careers_location+'&distance='+distance+'" class="btn btn-md btn-primary"><span class="glyphicon glyphicon-menu-right pull-right"></span>View Available Jobs</a>';

            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    infowindow.setContent(group_name);
                    infowindow.open(map, marker);
                }
            })(marker, i));

        });


        google.maps.event.addListener(map, 'click', function(event){
          this.setOptions({
            scrollwheel:true,
            draggable:true,
            });
        });
    }
});

if (document.querySelector('#careers-search-form')) {
    $('#careers-search-form').on('submit.analytics', function () {
        dataLayer.push({
            'event' : 'trackEvent',
            'eventCategory' : 'Careers - Search Form',
            'eventAction' : 'Search',
            'eventLabel' : 'Clicked',
            'eventValue' : 0,
        });
        return true;
    })
}
$('.ga-careers-email-header').click(function (e) {
    dataLayer.push({
        'event' : 'trackEvent',
        'eventCategory' : 'Careers - Email Us',
        'eventAction' : 'Link Clicked',
        'eventLabel' : 'Header',
        'eventValue' : 0,
    });
});
$('.ga-careers-email-footer').click(function (e) {
    dataLayer.push({
        'event' : 'trackEvent',
        'eventCategory' : 'Careers - Email Us',
        'eventAction' : 'Link Clicked',
        'eventLabel' : 'Footer',
        'eventValue' : 0,
    });
});
$('#ga-careers-apply-button').click(function (e) {
    dataLayer.push({
        'event' : 'trackEvent',
        'eventCategory' : 'Careers - Apply Nav',
        'eventAction' : 'Nav Link Clicked',
        'eventLabel' : 'Desktop',
        'eventValue' : 0,
    });
});
$('#ga-careers-apply-button-mobile').click(function (e) {
    dataLayer.push({
        'event' : 'trackEvent',
        'eventCategory' : 'Careers - Apply Nav',
        'eventAction' : 'Nav Link Clicked',
        'eventLabel' : 'Mobile',
        'eventValue' : 0,
    });
});
